module.exports = __webpack_public_path__ + "img/welfare.dea91780.svg";